import React from "react";
import PropTypes from "prop-types";

import Overlay from "components/Overlay";
import Carousel from "components/Carousel";

import "./WelcomeGuide.css";

const swiperOptions = {
  spaceBetween: 50,
  /** @see {@link http://idangero.us/swiper/api/#pagination} */
  pagination: {
    el: ".welcome-guide__pagination",
    bulletClass: "welcome-guide__pagination-bullet",
    bulletActiveClass: "welcome-guide__pagination-bullet--active"
  }
}

/**
 * Basis for T2P and SM welcome guides.
 */
export default class WelcomeGuide extends React.Component {
  
  static propTypes = {
    cssModifier: PropTypes.string,
    logoPath: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.node
  }
  
  state = {
    currentSlideIndex: 0
  }
  
  onSlideChange = currentSlideIndex => {
    this.setState({ currentSlideIndex });
  }
  
  onNextClick = () => {
    this.setState({ currentSlideIndex: this.state.currentSlideIndex + 1 });
  }
  
  render() {
    
    const { cssModifier, logoPath, isOpen, onClose, children } = this.props;
    const { currentSlideIndex } = this.state;
    const isLastSlide = currentSlideIndex === children.length - 1;
    
    if (!isOpen) {
      return null;
    }
    
    const classNames = [ "welcome-guide" ];
    if (cssModifier) {
      classNames.push(`welcome-guide--${cssModifier}`);
    }
    
    return (
      <Overlay>
        <div className={classNames.join(" ")}>
          <div className="welcome-guide__logo">
            <img src={logoPath} alt="product logo" />
          </div>
          <Carousel cssBlockName="welcome-guide" swiperOptions={swiperOptions} activeIndex={currentSlideIndex} onChange={this.onSlideChange}>
            { children }
          </Carousel>
          <div className="welcome-guide__controls">
            { isLastSlide ? null : <div className="welcome-guide__skip-button" onClick={onClose}>Skip</div> }
            <div className="welcome-guide__pagination"></div>
            {
              isLastSlide ?
              <div className="welcome-guide__done-button" onClick={onClose}>Got it!</div> :
              <div className="welcome-guide__next-button" onClick={this.onNextClick}>Next</div>
            }
          </div>
        </div>
      </Overlay>
    );
    
  }
  
}



// WEBPACK FOOTER //
// ./src/components/WelcomeGuide.js